module.exports = __webpack_public_path__ + "static/media/ic_template_15.dbe21079.png";